import { render, staticRenderFns } from "./ConfirmPage.vue?vue&type=template&id=1264ef04&scoped=true"
import script from "./ConfirmPage.vue?vue&type=script&lang=js"
export * from "./ConfirmPage.vue?vue&type=script&lang=js"
import style0 from "./ConfirmPage.vue?vue&type=style&index=0&id=1264ef04&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1264ef04",
  null
  
)

export default component.exports